/**
 * Moves the control with the provided ID to the overflow menu.
 */
export interface MoveToOverflow {
  type: "MoveToOverflow";

  /**
   * The ID of the control that is going to be impacted by this scaling step
   */
  controlId: string;
}

export const overflowIdSuffix = "overflow";
export const moveToOverflowScalingClassName = "mto";
export const singleMoveToOverflowScalingClassNameIndex = -1;
export const singleRibbonOverflowMenuId = "RibbonOverflowMenu";
